import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import "react-datepicker/dist/react-datepicker.css";

const DateInput = (props) => {
  const { t } = useTranslation();
  const getInitialDate = () => {
    if (props.defaultDate) {
      const d = new Date(props.defaultDate);
      if (!isNaN(d.getTime())) return d;
    }
    return props.id === "dateofstartPolicy" ? new Date() : null;
  };
  const [startDate, setStartDate] = useState(getInitialDate);

  React.useEffect(() => {
    if (props.defaultDate) {
      const d = new Date(props.defaultDate);
      if (!isNaN(d.getTime())) {
        setStartDate(d);
      }
    }
  }, [props.defaultDate]);

  function handledatetime(date) {
    setStartDate(date);
    setTimeout(() => {
      if (
        props.id === "dateofbirth" ||
        props.id === "dateofstartPolicy" ||
        props.id === "parent_age"
      ) {
        props?.handlePoliciesBasedOnAge();
      }
      if (props.id === "nominee_dob") {
        props.handleNomineePorichoy();
      }
    }, 500);
  }

  // Conditionally set minDate and maxDate only if the id is "dateofstartPolicy"
  // Policy document start date allows from Jan 1st of current year to Today.
  const currentYear = new Date().getFullYear();
  const minDate = props.id === "dateofstartPolicy" ? new Date(currentYear, 0, 1) : null;
  const maxDate = props.id === "dateofstartPolicy" ? new Date() : null;

  return (
    <DatePicker
      selected={startDate}
      onChange={(date) => handledatetime(date)}
      className="form-control"
      placeholderText={
        props?.id === "dateofstartPolicy"
          ? t("placeholder_doc")
          : t("placeholder_dob")
      }
      id={props.id}
      dateFormat="yyyy/MM/dd"
      peekNextMonth
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      autoComplete="off"
      minDate={minDate}
      maxDate={maxDate}
      {...props}
    />
  );
};


export default DateInput;
